import React from "react";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { VerticalTemplates } from "../../../../../../services/Templates";

const CtaPreviewModal = ({ element, onClose }) => {
  if (!element) {
    return null;
  }

  const PreviewComponent =
    element.type === "prompter"
      ? VerticalTemplates["prompter"]?.preview
      : VerticalTemplates[element.displayStyle]?.preview;

  const settings = element.settings
    ? typeof element.settings === "string"
      ? JSON.parse(element.settings)
      : element.settings
    : {};

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-[#00000070]">
      <div
        className={`bg-[#1c1c1e] text-white rounded-lg p-6 ${
          element.type === "prompter" ? "w-full max-w-2xl" : "w-full max-w-md"
        } relative`}
      >
        <button
          onClick={onClose}
          className="absolute top-2 right-2 p-1 hover:bg-gray-700 rounded text-white"
        >
          <IoMdCloseCircleOutline className="w-5 h-5" />
        </button>
        <h3 className="text-xl font-bold mb-4">{element.name}</h3>
        <div className="cta-preview-container">
          {PreviewComponent && (
            <PreviewComponent {...settings} preview={true} />
          )}
        </div>
      </div>
    </div>
  );
};

export default CtaPreviewModal;
